import { getIsUnplannedReactiveScope } from 'pages/WellGuardian/WIR/utils';
import { WIRCreateJourneyStepsKeys } from 'pages/WellGuardian/WIR/wir.constants';
import { WIR } from 'types/wellGuardian';

import { getFinalWirSectionKey } from './getSectionData';

export const getFinalWirReactiveScopeData = (wir: WIR | null, countrySelect: string) => {
  const phase = getIsUnplannedReactiveScope(wir)
    ? WIRCreateJourneyStepsKeys.REACTIVE_SCOPE
    : getFinalWirSectionKey(countrySelect);
  const finalWirSignOff = wir?.phases?.[phase]?.sections?.finalWirSignOff;
  const managerialSummary = wir?.phases?.[phase]?.sections?.managerialSummary;
  const assignInterventionSPDT = wir?.phases?.[phase]?.sections?.assignInterventionSPDT;

  return {
    phase,
    finalWirSignOff,
    managerialSummary,
    assignInterventionSPDT,
  };
};
